<template>
  <v-select
    :items="daysOptions"
    :label="label"
    :disabled="disabled"
    :readonly="readonly"
    v-model="dayValue"
    outlined
  ></v-select>
</template>

<script>
export default {
  props: [
    'label',
    'day',
    'daysOptions',
    'disabled',
    'readonly'
  ],
  computed: {
    dayValue: {
      get () {
        return this.day
      },
      set (newValue) {
        this.$emit('dayChange', newValue)
      }
    }
  }
}
</script>
